import React from 'react';
import AttentionTutorial from './components/AttentionTutorial';

function App() {
  return (
    <div className="App">
      <AttentionTutorial />
    </div>
  );
}

export default App;
